import { navigateToStep } from '../../utils/navigate-to-step';
import { buildCampaignContentUrl } from '../../../utils/url-builders';
export var goToPreviousStep = function (params) {
    var previousStepPathname = buildCampaignContentUrl({
        session: params.session,
        campaignId: params.campaignId,
    });
    navigateToStep({
        store: params.store,
        navigate: params.navigate,
        stepPathname: previousStepPathname,
    });
};
